/**
 * Preferencias que sao precisas ANTES de a base de dados abrir.
 *
 * As configuracoes normais vivem em `core.settings` (IndexedDB). Mas a lista de
 * plugins desligados tem de ser conhecida antes de registrar seja o que for — as
 * tabelas do IndexedDB nascem dos manifestos, e nessa altura ainda nao ha
 * configuracoes carregadas. Por isso esta lista fica no `localStorage`, que e
 * sincrono, e e escrita nos dois lugares para o diagnostico bater certo.
 */
const DISABLED_KEY = 'flos.plugins.disabled';

function storage(): Storage | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage;
  } catch {
    return null;
  }
}

export function readDisabledPlugins(): string[] {
  const store = storage();
  if (!store) return [];
  try {
    const raw = store.getItem(DISABLED_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string') : [];
  } catch {
    return [];
  }
}

export function writeDisabledPlugins(ids: readonly string[]): void {
  const store = storage();
  if (!store) return;
  try {
    store.setItem(DISABLED_KEY, JSON.stringify([...new Set(ids)]));
  } catch {
    // Sem persistencia a escolha vale so ate fechar. Melhor do que quebrar.
  }
}
